
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#000","d":"M2.201 9.854a.492.492 0 01-.18-.54l.08-.249a.493.493 0 01.44-.35l6.384-.51 2.448-5.884a.51.51 0 01.51-.32h.259a.492.492 0 01.47.32l2.457 5.885 6.384.51c.205.012.38.152.44.349l.08.25a.494.494 0 01-.15.54l-4.816 4.136 1.479 6.204a.511.511 0 01-.19.53l-.29.16a.501.501 0 01-.56 0l-5.434-3.298-5.465 3.327a.498.498 0 01-.56 0l-.219-.15a.508.508 0 01-.19-.53l1.439-6.243L2.2 9.854z"}})])])
          )
        }
      }
    